<div class="row-auto title-container">
    <div class="resource-title-container w-100">
        <app-resource-subtitle></app-resource-subtitle>
    </div>
</div>
<div
    class="row-auto audio-container"
    [ngClass]="{ 'caution-flags-audio-container': isCautionFlagContainerDisplayed }"
>
    <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-8 order-2 order-md-2 order-lg-1 py-4 pe-lg-2 pe-sm-4 ps-4"
    >
        <app-sensitive-content-container
            *ngIf="isCautionFlagContainerDisplayed"
            [actionButtonName]="'Listen'"
            [resource]="resource"
            [customAction]="true"
            (customActionTrigger)="playAudio()"
            [customClasses]="'audio'"
            class="content-flags-overlay"
        >
        </app-sensitive-content-container>
        <app-audio-preview
            *ngIf="resource"
            [audioMedia]="resource.getSelectedMedia()"
            [muxData]="muxData"
            [gtmVideoJsInfo]="gtmVideoJsInfo"
        >
        </app-audio-preview>
    </div>
    <div class="poster-image col-md-12 col-lg-4 order-1 order-md-1 order-lg-2 py-4 ps-2 pe-4">
        <div>
            <img
                [src]="resource.getSelectedMedia().posterImage.itsURL"
                [alt]="resource.getSelectedMedia().posterImage.altText"
            />
        </div>
    </div>
</div>
<div class="row">
    <div class="col-lg-8">
        <app-resource-details></app-resource-details>
    </div>
    <div class="col-lg-4 recommended selenium-related-resources">
        <app-support-material-panel
            [resource]="resource"
            *ngIf="!windowSize.isTablet"
            style="margin-bottom: 30px"
        >
        </app-support-material-panel>
        <ng-container *ngIf="!isAddonView">
            <app-related-resources
                *ngIf="resource"
                [resource]="resource"
                class="selenium-you-may-also-like"
            >
            </app-related-resources>
            <app-curriculum-tags></app-curriculum-tags>
        </ng-container>
    </div>
</div>
<div class="row-auto" *ngIf="!isAddonView">
    <app-more-from-collection></app-more-from-collection>
</div>
